import gql from 'graphql-tag';

export const UpdateLostAndFoundIssue = gql`
  mutation UpdateLostAndFoundIssueBulk($input: UpdateLostAndFoundIssueBulkInput!) {
    updateLostAndFoundIssueBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
